import { http } from "@/utils/http";
import { TokenData } from "./qiniu.d";
import { ResponseResult } from "./common";

/** 获取七牛上传token */
export const fetchQiniuToken = () => {
  return http.request<ResponseResult<TokenData>>(
    "post",
    "/qiniu/getToken"
  );
};

/** 获取七牛上传token */
export const fetchQiniuTokenWithoutAuth = (key: string) => {
  return http.request<ResponseResult<TokenData>>(
    "post",
    "/qiniu/getTokenSecret",
    {
      data: { key }
    }
  );
};